import { makeStyles } from '@material-ui/core/styles'
import Grid from '@material-ui/core/Grid'
import Typography from '@material-ui/core/Typography'

import useTranslate from '../../../i18n/useTranslate'

interface Props {
    isEmpty: boolean
}

const EmptyData: React.FC<Props> = ({ children, isEmpty }) => {
    const classes = useStyles()
    const translate = useTranslate()

    return isEmpty ? (
        <Grid
            container
            justify="center"
            className={classes.empty}
            alignItems="center"
            style={{ border: '1px solid rgba(0, 0, 0, .125)' }}
        >
            <Typography variant="h6">{translate.get('UM.USERGROUP.EMPTY-CONTENT')}</Typography>
        </Grid>
    ) : (
        <>{children}</>
    )
}

const useStyles = makeStyles((theme) => ({
    empty: {
        padding: theme.spacing(1),
        height: '100%',
        // borderRadius: 4,
        // border: '1px solid #bdbdbd',
    },
}))

export default EmptyData
